import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NbGlobalPhysicalPosition, NbToastrService } from '@nebular/theme';

@Injectable({ providedIn: 'root' })
export class ErrorHandlerService {
  constructor(private toastrService: NbToastrService) {}

  handle(error: any, form?: FormGroup, toastOptions?: any) {
    const err = typeof error === 'function' ? error() : error;

    // ------------------------------
    // Handle Form Validation Errors
    // ------------------------------
    if (form && Array.isArray(err?.error?.message)) {
      err.error.message.forEach((validationError: any) => {
        const field = validationError.field;
        const messages = validationError.messages;

        const control = form.get(field);
        if (control) {
          control.setErrors({ backend: messages.join(', ') });
        }
      });
    }

    // ------------------------------
    // Handle Toast Message
    // ------------------------------
    const message = err?.error?.persianMessage || err?.error?.message;

    if (message) {
      this.toastrService.show(message, 'خطا در هنگام ثبت', {
        destroyByClick: true,
        duration: 5000,
        position: NbGlobalPhysicalPosition.BOTTOM_RIGHT,
        preventDuplicates: false,
        status: 'danger',
        ...(toastOptions || {}),
      });
    }
  }
}
